<template>
  <div>
    <div class="toolbtn flex">
      <switchcore></switchcore>
      <el-tooltip class="item" effect="dark" content="刷新" placement="top">
        <div @click="refresh()" class="cursorpointer margin-top10">
          <img
            src="@/assets/barsvg/icon／12sx(1).png"
            style="position: relative; top: 2px"
            alt=""
          />
          <span class="f12 pad-left5" style="color: #969eac">刷新</span>
        </div>
      </el-tooltip>
      <el-tooltip class="item" effect="dark" content="返回" placement="top">
        <callback></callback>
      </el-tooltip>
    </div>
    <!-- 关键词检索  -->
    <div
      class="width100 margin-auto backwhite border-rd3 flex-betweenwrap"
      style="min-height: 72px"
      v-if="serchkey"
    >
      <el-form
        ref="ruleForm"
        size="small"
        label-width="80px"
        class="demo-ruleForm flexleft"
      >
        <el-form-item label="报告名称">
          <el-input placeholder="请输入报告名称" v-model="input"></el-input>
        </el-form-item>
        <div class="pad-left20">
          <el-button type="primary" @click="submitForm()">检 索</el-button>
          <el-button @click="resetForm()" class="resetbtn">重 置</el-button>
        </div>
      </el-form>
    </div>

    <el-skeleton
      class="width100"
      :loading="loading"
      animated
      :throttle="500"
      v-if="total != 0"
    >
      <template slot="template">
        <div
          class="
            width100
            margin-top15 margin-auto
            backwhite
            pad-top20
            border-rd3
            alldigital
          "
        >
          <el-table :data="page" stripe class="eltable width98 margin-auto">
            <el-table-column label="报告名称" prop="title" />
            <el-table-column label="关键词" align="center" prop="2" />
            <el-table-column label="报告页数" align="center" prop="page" />
            <el-table-column
              label="报告生成时间"
              align="center"
              prop="create_time"
            />
            <el-table-column
              label="操作"
              align="center"
              class-name="small-padding fixed-width"
            >
              <template slot-scope="scope">
                <div class="cursorpointer">
                  <span style="color: #52c5cb" @click="previewreport(scope.row)"
                    >预览报告</span
                  >
                  <span
                    class="pad-left10"
                    style="color: #52c5cb"
                    @click="downloadreport(scope.row)"
                    >下载报告</span
                  >
                </div>
              </template>
            </el-table-column>
          </el-table>
          <div
            v-if="total != 0"
            class="flex-betweennowrap pad-top20 width98 margin-auto pad-bot20"
          >
            <span class="bluecolor f14"></span>
            <el-pagination
              :hide-on-single-page="true"
              @size-change="handleSizeChange"
              @current-change="currentchange"
              :current-page="currentPage"
              :page-sizes="[10, 20, 30, 40, 50]"
              :page-size="per_page"
              layout="total, sizes, prev, pager, next, jumper"
              :total="total"
              background
            >
            </el-pagination>
          </div>
        </div>
      </template>
    </el-skeleton>
    <div
      class="width100 margin-auto backgroudFFF margin-top15"
      v-if="total == 0"
    >
      <el-empty
        :image="require('@/assets/barsvg/zwsj@3x.png')"
        :image-size="200"
        description="抱歉，没有搜到您想要的内容"
        class="heightempty"
        ><p style="position: relative; bottom: 60px" class="f14">
          暂无数据
        </p></el-empty
      >
    </div>

    <el-dialog
      title=""
      :visible.sync="dialogVisiblenull"
      :close-on-click-modal="false"
      :show-close="true"
      :center="true"
      :modal="true"
      :modal-append-to-body="true"
      :append-to-body="true"
      width="25%"
      class="errorbox"
    >
      <p class="textalign-left f16">提示</p>
      <div class="textalign-left margin-top10">
        <span class="errormessage">{{ errormessage }}</span>
      </div>
      <span slot="footer" class="dialog-footer">
        <span @click="dialogVisiblenull = false" class="errorbutton">
          确 定
        </span>
      </span>
    </el-dialog>
  </div>
</template>
 <script>
import { Navigationreport } from "@/api/Center/Center.api";
import callback from "@/components/callback.vue";
import BUS from "@/BUS/BUS";
import switchcore from "@/components/switchcore.vue";
export default {
  data() {
    return {
      loading: true,
      errormessage: "",
      dialogVisiblenull: false,
      ruleForm: {
        pipo: "",
      },
      thisNum: 1,
      currentPage: 1,
      page: [],
      total: 0,
      per_page: 0,
      progres: { background: "red" },
      progress: "",
      serchkey: true,
      input: "",
    };
  },
  components: {
    callback,
    switchcore,
  },
  methods: {
    submitForm() {
      Navigationreport({
        _keywords: this.input,
        page: 1,
      }).then((res) => {
        if (res.data.code == 200) {
          this.pagination = true;
          this.page = res.data.data.data;
          this.total = res.data.data.total;
          this.per_page = res.data.data.per_page;
        } else {
          this.drawer = false;
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },

    // 预览报告
    previewreport(index) {
      this.$router.push({
        path: "/development-Administration/navigation-report",
      });
      window.sessionStorage.setItem("report_url", this.page[index].report_url);
    },
    // 下载报告
    downloadreport(index) {
      let a = document.createElement("a");
      a.href = this.page[index].report_url;
      a.click();
    },
    // 第一个分页
    currentchange(val) {
      Navigationreport({
        page: val,
        _keywords: this.input,
      }).then((res) => {
        if (res.data.code == 200) {
          this.page = res.data.data.data;
          this.total = res.data.data.total;
          this.per_page = res.data.data.per_page;
        } else {
          this.drawer = false;
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    handleSizeChange(val) {
      Navigationreport({
        page: 1,
        limit: val,
        _keywords: this.input,
      }).then((res) => {
        if (res.data.code == 200) {
          this.page = res.data.data.data;
          this.total = res.data.data.total;
          this.per_page = res.data.data.per_page;
        } else {
          this.drawer = false;
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    // input重 置
    resetForm() {
      this.input = null;
      Navigationreport({
        page: this.thisNum,
      }).then((res) => {
        this.pagination = true;
        this.page = res.data.data.data;
        this.total = res.data.data.total;
        this.per_page = res.data.data.per_page;
        if (res.data.code == 200) {
          this.drawer = false;
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    refresh() {
      this.$loading.show(); // 显示loading
      Navigationreport({
        page: this.thisNum,
      }).then((res) => {
        if (res.data.code == 200) {
          this.$loading.hide(); // 隐藏loading
          this.pagination = true;
          this.page = res.data.data.data;
          this.total = res.data.data.total;
          this.per_page = res.data.data.per_page;
        } else {
          this.$loading.hide(); // 隐藏loading
          this.drawer = false;
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
  },
  created() {
    BUS.$on("serchkey", (data) => {
      this.serchkey = data;
    });

    if (window.sessionStorage.getItem("navigetionval") == null) {
      this.thisNum = 1;
      this.currentPage1 = 1;
    } else {
      this.thisNum = window.sessionStorage.getItem("navigetionval");
      this.currentPage1 = parseInt(
        window.sessionStorage.getItem("navigetionval")
      );
    }

    Navigationreport({
      page: this.thisNum,
    }).then((res) => {
      this.pagination = true;
      this.page = res.data.data.data;
      this.total = res.data.data.total;
      this.per_page = res.data.data.per_page;
      if (res.data.code == 200) {
        this.drawer = false;
      } else {
        this.dialogVisiblenull = true;
        this.errormessage = res.data.msg;
      }
    });
  },
};
</script>
<style scoped>
.eltable >>> .el-table__header-wrapper th {
  background-color: #f8f8f9;
  height: 40px;
  font-size: 13px;
}
.errorbox >>> .el-dialog__body {
  text-align: center;
}
.errorbox >>> .el-dialog {
  position: relative;
  top: 20%;
}
</style>